<script lang="ts" setup>
import BaseInput from "@/components/base/BaseInput.vue";
import PremiumNumbersCategory from "@/components/premium/PremiumNumbersCategory.vue";
import PremiumPhonesModals from "@/components/premium/PremiumPhonesModals.vue";
import { usePremiumPhones } from "@/composables/premium/usePremiumPhones";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

const {
  activeTab,
  activeNumber,
  activeNumberPrice,
  activeNumberType,
  changeNumberToPremium,
  closeSuccessModal,
  errorModal,
  errorSixMonthsModal,
  formatPhone,
  isLoadingChangeNumber,
  openModal,
  openModalFirstPayment,
  openModalLowMoney,
  openModalSecondPayment,
  openModalTwoParts,
  searchValue,
  selectNumber,
  showMoreCategory,
  successModal,
  t,
  tabs,
  tabsClasses,
  toPayment,
  walletAmount,
  walletAmountCalc,

  isLoadingListing,
  clickTab,
  loadMore,
  visibleCategories,
  isAllCategoriesEmpty,
  premiumNumbersMap,
  configDataBrand,
} = usePremiumPhones();
</script>

<template>
  <div class="premium-phones">
    <div class="premium-phones-header">
      <router-link to="account" class="premium-phones-header__back">
        <BaseFigureForIcon
          size="medium"
          color="white"
          icon="arrow"
          position="left"
          is-button
        />
      </router-link>
      <div class="premium-phones-header__title">
        <p class="h3">{{ t("premium.title") }}</p>
      </div>
    </div>
    <div class="premium-phones-mobile_header">
      <p class="h1">{{ t("premium.title") }}</p>
    </div>
    <div class="premium-phones--body">
      <div class="premium-phones--body-title">
        <p class="h1">{{ t("premium.selectNumber") }}</p>
      </div>
      <div class="premium-phones--body-search">
        <BaseInput
          v-model="searchValue"
          type="digit"
          :max-length="11"
          :placeholder="t('premium.searchPlaceholder')"
        />
      </div>
      <div class="premium-phones--body-tabs">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          class="premium-phones--body-tab caption-navbar"
          :class="tabsClasses(item.name)"
          @click="clickTab(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="premium-phones--body-main">
        <Transition name="fade">
          <div v-if="isLoadingListing" class="premium-phones--body-loader">
            <div class="premium-phones--body-loader-pic">
              <img :src="configDataBrand.assets.loader" alt="Загрузка" />
            </div>
          </div>
        </Transition>
        <template v-for="category in visibleCategories" :key="category.id">
          <PremiumNumbersCategory
            v-if="
              !(
                activeTab.name === 'all' &&
                !premiumNumbersMap.get(category?.name)?.numbers?.length
              )
            "
            :isLoadingListing="isLoadingListing"
            :searchValue="searchValue"
            :active-number="activeNumber"
            :format-phone="formatPhone"
            :numbers="premiumNumbersMap.get(category?.name)?.numbers"
            :isFilled="premiumNumbersMap.get(category?.name)?.isFilled"
            :title="category.displayName"
            @select="selectNumber"
            @show-more="loadMore(category.name)"
          />
        </template>
        <div
          v-if="isAllCategoriesEmpty && !isLoadingListing"
          class="premium-phones--body-category_empty"
        >
          <p class="caption-medium">
            {{ t("premium.notFound") }}
          </p>
        </div>
      </div>
    </div>

    <PremiumPhonesModals
      :active-number="activeNumber"
      :active-number-price="activeNumberPrice"
      :active-number-type="activeNumberType"
      :error-modal="errorModal"
      :error-six-months-modal="errorSixMonthsModal"
      :format-phone="formatPhone"
      :is-loading-change-number="isLoadingChangeNumber"
      :open-modal="openModal"
      :open-modal-first-payment="openModalFirstPayment"
      :open-modal-low-money="openModalLowMoney"
      :open-modal-second-payment="openModalSecondPayment"
      :open-modal-two-parts="openModalTwoParts"
      :success-modal="successModal"
      :wallet-amount="walletAmount"
      :wallet-amount-calc="walletAmountCalc"
      @close-confirm="openModal = false"
      @close-error="errorModal = false"
      @close-first-payment="openModalFirstPayment = false"
      @close-low-money="openModalLowMoney = false"
      @close-second-payment="openModalSecondPayment = false"
      @close-six-months-error="errorSixMonthsModal = false"
      @close-success="closeSuccessModal"
      @close-two-parts="openModalTwoParts = false"
      @confirm="changeNumberToPremium"
      @continue-to-first-payment="
        openModalTwoParts = false;
        openModalFirstPayment = true;
      "
      @continue-to-second-payment="
        toPayment();
        openModalFirstPayment = false;
        openModalSecondPayment = true;
      "
      @to-payment="toPayment"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/premium";
</style>
